import React from "react";
import { Spinner } from "reactstrap";

export default function LoadingSpinner({
  color = "primary",
  size,
  text,
  fullPage = false
}) {
  return (
    <div className={`fd-loading ${fullPage ? "fd-loading--page" : ""}`} role="status" aria-live="polite">
      <Spinner color={color} size={size === "sm" ? "sm" : undefined} style={size === "lg" ? { width: "3rem", height: "3rem" } : undefined} />
      {text && <p className="mb-0">{text}</p>}
    </div>);

}
